var map = {
	"./0.jfif": "9169",
	"./class_schedule.png": "54e0",
	"./flex_jeans.jpg": "1e73",
	"./oil.png": "5e6a",
	"./pc_crash.png": "8e70",
	"./shmoke.mp3": "bfae",
	"./smoke.gif": "4e11",
	"./sous_vide.png": "6b6a",
	"./substance.gif": "62e1",
	"./tenor.gif": "209a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09ae";